import { Typography } from "@mui/material";
import StudentCard from "./StudentCard";
import { useAppSelector } from "app/hooks";
import { selectSelectedDataList, selectStudentList } from "features/students";
const customStyles = {
  root: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)", // 2 columns per row
    gridGap: "1cm",
    width: "100%",
    padding: "0 1cm",
    "& div:nth-of-type(4n)": {
      pageBreakAfter: "always" /* Break after 4 cards */,
    },
  },
  card: {
    paddingTop: "1cm",
    pageBreakInside: "avoid", // Prevent breaking inside a page
    breakInside: "avoid", // Prevent breaks inside items
  },
};
const StudentsPrint = () => {
  const studentList = useAppSelector(selectStudentList);
  const selectedDataList = useAppSelector(selectSelectedDataList);
  const data = studentList.filter((stu) => selectedDataList?.includes(stu._id));

  return data.length === 0 ? null : (
    <Typography component="div" sx={customStyles.root}>
      {data.map((item, index) => (
        <Typography component="div" key={"key" + index} sx={customStyles.card}>
          <StudentCard
            name={item._name}
            grade={item._gradeName}
            className={item._className}
            QRcode={item._deepLinkHome}
            studentCode={item._studentUUIDCode}
          />
        </Typography>
      ))}
    </Typography>
  );
};

export default StudentsPrint;
